import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../theme';
import { absolute } from '../styles/mixins';

export const useModalPageStyles = createStyles(({ token }) => ({
  root: absolute(),
  content: {
    width: '100%',
    height: '100%',
    minWidth: token.screenXSMin,
    display: 'flex',
    flexDirection: 'column',
    padding: `${ThemeSpaces.SPACE_NORM_30}px 100px`,

    [`@media (max-width: ${token.screenMDMax}px)`]: {
      padding: `${ThemeSpaces.SPACE_NORM_30}px ${ThemeSpaces.SPACE_NORM}px`,
    },
  },
  innerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: `${ThemeSpaces.SPACE_NORM_20}px 0`,

    [`@media (max-width: ${token.screenMDMax}px)`]: {
      margin: `${ThemeSpaces.SPACE_NORM}px 0`,
    },
  },
}));
